import { safeGet } from '../../../utils/safeGet'
import { get as _get, post as _post, fetchCustomMethod } from '../../../utils/fetcher'

export default {
  namespaced: true,
  state: {
    pagination: {
      perPage: 25,
      currentPage: 1,
      items: 0,
    },
    sortingValue: '',
    searchBarValue: '',
    modelsList: [],
    modelsListToAssociate: [],
    loading: false,
  },
  mutations: {
    setPagination(state, data) {
      state.pagination = data
    },
    setSortingValue(state, data) {
      state.sortingValue = data
    },
    setSearchBarValue(state, data) {
      state.searchBarValue = data
    },
    setPaginationPerPage(state, data) {
      state.pagination.perPage = data
    },
    setPaginationCurrentPage(state, data) {
      state.pagination.currentPage = data
    },
    setModelsList(state, data) {
      state.modelsList = data
    },
    setModelsListToAssociate(state, data) {
      state.modelsListToAssociate = data
    },
    setLoading(state, data) {
      state.loading = data
    },
  },
  actions: {
    loadModelsList({ commit, getters }) {
      commit('setLoading', true)
      const payload = {
        Sf: getters.getSearchBarValue,
        Page: getters.getPagination.currentPage,
        Size: getters.getPagination.perPage,
        Sort: getters.getSortingValue,
      }
      return new Promise((resolve, reject) => {
        _post('/api/scoringProfileModels/list', payload)
          .then((data) => {
            commit('setPagination', {
              perPage: data.paging.pageSize,
              currentPage: data.paging.pageIndex,
              items: data.paging.totalItems,
            })
            commit('setModelsList', data.scoringProfileModels)
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },

    loadModelsListToAssociate({ commit, rootGetters }) {
      const payload = {
        Sf: '',
        Page: 1,
        Size: 10000,
        Sort: 'Name',
      }

      if (!rootGetters.can_ViewScoringProfileModels) return

      return new Promise((resolve, reject) => {
        _post('/api/scoringProfileModels/list', payload)
          .then((data) => {
            commit('setModelsListToAssociate', data.scoringProfileModels)
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },

    deleteModel({ dispatch }, modelId) {
      return new Promise((resolve, reject) => {
        fetchCustomMethod(`/api/scoringProfileModels/${modelId}`, 'DELETE', {})
          .then(() => {
            dispatch('loadModelsList')
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    checkProfileLinking({}, modelId) {
      return new Promise((resolve, reject) => {
        _get(`/api/scoringProfiles/LinkedToModel/${modelId}`)
          .then((data) => {
            let modelNames = []
            data.forEach((el) => modelNames.push(el.scoringProfileName))
            resolve(modelNames)
          })
          .catch((err) => reject(err))
      })
    },

    resetState({ state }) {
      state.pagination = {
        perPage: 25,
        currentPage: 1,
        items: 0,
      }
      state.sortingValue = ''
      state.searchBarValue = ''
      state.modelsList = []
      state.modelsListToAssociate = []
      state.loading = false
    },
  },
  getters: {
    getPagination: (state) => {
      return safeGet(() => state.pagination, {
        perPage: 25,
        currentPage: 1,
        items: 0,
      })
    },
    getSortingValue: (state) => {
      return safeGet(() => state.sortingValue, '')
    },
    getSearchBarValue: (state) => {
      return safeGet(() => state.searchBarValue, '')
    },
    getModelsList: (state) => {
      return safeGet(() => state.modelsList, [])
    },
    getLoading: (state) => {
      return safeGet(() => state.loading, false)
    },
    getModelsListToAssociate: (state) => {
      return safeGet(() => state.modelsListToAssociate, [])
    },
  },
}
